import { render, staticRenderFns } from "./AddRoomRenovation.vue?vue&type=template&id=15be3d22&scoped=true"
import script from "./AddRoomRenovation.vue?vue&type=script&lang=js"
export * from "./AddRoomRenovation.vue?vue&type=script&lang=js"
import style0 from "./AddRoomRenovation.vue?vue&type=style&index=0&id=15be3d22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15be3d22",
  null
  
)

export default component.exports